/* eslint-disable no-lonely-if */
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { AppThemeProvider } from "../../theme";
import defaultTheme from "../../theme/defaultTheme";
import ChatScreen from "../pages/ChatScreen";
import NotFoundPage from "../pages/NotFoundPage";
import LandingPage from "../pages/LandingPage";
import AppScreen from "../pages/AppScreen";
import ReliefManScreen from "../pages/ReliefManScreen";
import { getLoginAgainUrl } from "../../utils/loginUrl";
import { agenticMsalInstance } from "../../config/agenticMsalConfig";
import AgenticProtectedRoute from "./AgenticProtectedRoute";
import { intakeData } from "../../config/agentic/IntakeData";
import { benefitData } from "../../config/agentic/benefitData";
import { eligibilityData } from "../../config/agentic/eligibilityReviewConfig";
import { applicationStatusData } from "../../config/agentic/applicationStatusData";
import { applicationStatusConfig } from "../../config/agentic/applicationStatusConfig";
import { docAgentData } from "../../config/agentic/docAgentData";
import { duplicateConfig } from "../../config/agentic/duplicateConfig";
import { benefitDuplicateConfig } from "../../config/agentic/benefitDuplicateConfig";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

const AppRoutes = ({ logedInUserMail = '', logedInUserName = '' }) => {
  const [checkedSession, setCheckedSession] = useState(false);
  const [sessionExists, setSessionExists] = useState(false);

  useEffect(() => {
    const rawCookie = getCookie("session_exists") || "";
    const exists = rawCookie.toLowerCase() === "true" || rawCookie === "1";

    if (!exists) {
      window.location.replace(getLoginAgainUrl());
      return;
    }

    setSessionExists(true);
    setCheckedSession(true);
  }, []);

  if (!checkedSession) {
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/landing" replace />} />
      <Route path="/landing" element={<LandingPage logedInUserMail={logedInUserMail} />} />
      <Route
        path="/chat/:collaboration_id?"
        element={<ChatScreen logedInUserMail={logedInUserMail} logedInUserName={logedInUserName} />}
      />

      {/* Agentic subtree: session_exists cookie gate already passed above.
          A second MsalProvider + AgenticProtectedRoute enforces the agentic
          Azure AD app registration before rendering any agent page. */}
      <Route
        element={
          <AppThemeProvider theme={defaultTheme}>
            <MsalProvider instance={agenticMsalInstance}>
              <AgenticProtectedRoute />
            </MsalProvider>
          </AppThemeProvider>
        }
      >
        <Route path="/apps" element={<AppScreen logedInUserMail={logedInUserMail} />} />
        <Route path="/intake-agent" element={<ReliefManScreen {...intakeData} logedInUserMail={logedInUserMail} />} />
        <Route path="/benefit-agent" element={<ReliefManScreen {...benefitData} logedInUserMail={logedInUserMail} />} />
        <Route path="/eligibility-review-agent" element={<ReliefManScreen {...eligibilityData} logedInUserMail={logedInUserMail} />} />
        <Route path="/eligibility-review-report" element={<ReliefManScreen {...eligibilityData} logedInUserMail={logedInUserMail} />} />
        <Route path="/application-status-agent" element={<ReliefManScreen {...applicationStatusData} logedInUserMail={logedInUserMail} />} />
        <Route path="/application-status-report" element={<ReliefManScreen {...applicationStatusConfig} logedInUserMail={logedInUserMail} />} />
        <Route path="/doc-agent" element={<ReliefManScreen {...docAgentData} logedInUserMail={logedInUserMail} />} />
        <Route path="/documentQuality-report" element={<ReliefManScreen {...docAgentData} logedInUserMail={logedInUserMail} />} />
        <Route path="/duplicate-report" element={<ReliefManScreen {...duplicateConfig} logedInUserMail={logedInUserMail} />} />
        <Route path="/benefit-duplicate-report" element={<ReliefManScreen {...benefitDuplicateConfig} logedInUserMail={logedInUserMail} />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
